export default "__VITE_ASSET__DOPY1oAR__"